import { render, staticRenderFns } from "./PageSingleNominator.vue?vue&type=template&id=53d456f0"
import script from "./PageSingleNominator.vue?vue&type=script&lang=js"
export * from "./PageSingleNominator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports